import React, { useState, useEffect } from 'react'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'

const formatSSN = digits => {
  if (digits.length >= 5) {
    return digits.slice(0, 3) + '-' + digits.slice(3, 5) + '-' + digits.slice(5, 9)
  } else if (digits.length >= 3) {
    return digits.slice(0, 3) + '-' + digits.slice(3)
  } else {
    return digits
  }
}

const SSNInput = ({
  fullSSN,
  lastFour,
  onChange,
  onBlur,
  errors = {},
  initialShowFullSSN = true,
  className = '',
  isValid = false,
  isInvalid = false,
}) => {
  const [initialRender, setInitialRender] = useState(false)
  const [showFullSSN, setShowFullSSN] = useState(initialShowFullSSN)

  useEffect(() => {
    if (!initialRender && lastFour && !fullSSN) {
      setShowFullSSN(false)
    }
  }, [initialRender, lastFour, fullSSN])

  useEffect(() => {
    setInitialRender(true)
  }, [])

  const handleToggle = e => {
    e.preventDefault()
    setShowFullSSN(!showFullSSN)

    // Clear the hidden field when toggling
    if (showFullSSN) {
      // Switching to last 4 - clear full SSN
      onChange({
        target: {
          name: 'metadata.ssn',
          value: '',
        },
      })
    } else {
      // Switching to full SSN - clear last 4
      onChange({
        target: {
          name: 'metadata.ssn_last_four',
          value: '',
        },
      })
    }
  }

  const handleChange = e => {
    const { name, value } = e.target

    if (name === 'metadata.ssn') {
      // Extract only digits from input
      const newDigits = value.replace(/\D/g, '').slice(0, 9)

      // Format the SSN for display
      const formattedSSN = formatSSN(newDigits)

      // Update parent component with formatted SSN
      onChange({
        target: {
          name,
          value: formattedSSN,
        },
      })
    } else {
      // Handle last four digits input
      const lastFourDigits = value.replace(/\D/g, '').slice(0, 4)
      onChange({
        target: {
          name,
          value: lastFourDigits,
        },
      })
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }} className={className}>
      {showFullSSN ? (
        <FloatingLabel controlId='floatingSSN' label='Full SSN'>
          <Form.Control
            type='text'
            name='metadata.ssn'
            placeholder='Full SSN'
            value={fullSSN || ''}
            onChange={handleChange}
            onBlur={onBlur}
            isValid={isValid}
            isInvalid={isInvalid || !!errors.ssn}
          />
          <Form.Control.Feedback type='invalid'>{errors.ssn?.join(', ')}</Form.Control.Feedback>
          <Form.Control.Feedback type='valid'></Form.Control.Feedback>
        </FloatingLabel>
      ) : (
        <FloatingLabel controlId='floatingSSNLast4' label='Last 4 of SSN'>
          <Form.Control
            type='text'
            name='metadata.ssn_last_four'
            placeholder='Last 4 of SSN'
            value={lastFour || ''}
            onChange={handleChange}
            onBlur={onBlur}
            isValid={isValid}
            isInvalid={isInvalid || !!errors.ssn_last_four}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.ssn_last_four?.join(', ')}
          </Form.Control.Feedback>
          <Form.Control.Feedback type='valid'></Form.Control.Feedback>
        </FloatingLabel>
      )}
      <a href='#' onClick={handleToggle} className='text-muted small text-decoration-underline'>
        {showFullSSN
          ? 'I only want to enter the last four digits.'
          : 'I want to enter the full SSN.'}
      </a>
    </div>
  )
}

export default SSNInput
